<waitLoading *ngIf="isLoading()"></waitLoading>
<p-scrollPanel [style]="{width: '100%', height: '60vh'}" styleClass="custombar1">
  <div class="container-fluid" *ngIf="!isLoading()">
    <div class="row m-t-xs">
      <div class="col-12">
        <p-panel>
          <p-header>
            <span class="leyenda float-right">{{ 'Audit.total' | translate }} {{ reportList ? reportList.length : '0' }}
              informes</span>
          </p-header>
          <div class="row">
            <div class="col-12">
              <input type="text" class="p-inputtext w-100" placeholder="{{ 'Documents.write.filter' | translate }}"
                name="filterText" id="filterTextInput" autocomplete="off" [(ngModel)]="filterText"
                (ngModelChange)="updateFilter()" />
            </div>
          </div>
          <p-table [value]="filteredReportList" [responsive]="true">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th class="col-icon"></th>
                <th class=""></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-report>
              <tr>
                <td class="col-icon">
                  <span><i class="fa fa-chart-bar fa-lg"></i><span class="sr-only"></span>
                  </span>
                </td>
                <td>
                  <a (click)="selectReport(report)">{{ report.name }}</a>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr class="text-center">
                <td [attr.colspan]="columns.length"> {{ 'General.noFilteredData' | translate }} </td>
              </tr>
            </ng-template>
          </p-table>
        </p-panel>
      </div>
    </div>
  </div>
</p-scrollPanel>